import React from 'react';
import {useLocation, useNavigate} from 'react-router-dom';

import {getCookie, removeCookie} from '../../../api/cookie';

import {ListItemIcon, ListItemText, MenuItem, MenuList} from '@mui/material';
import AdminPanelSettingsOutlinedIcon from '@mui/icons-material/AdminPanelSettingsOutlined';
import HomeOutlinedIcon from '@mui/icons-material/HomeOutlined';
import LightbulbOutlinedIcon from '@mui/icons-material/LightbulbOutlined';
import LogoutRoundedIcon from '@mui/icons-material/LogoutRounded';

export default function MenuBox() {
    const navigate = useNavigate();
    const location = useLocation();

    const isAdmin = getCookie('administrator');
    const isOnIdea = location.pathname.startsWith('/idea');

    const handleLogout = () => {
        removeCookie('accessToken', { path: '/' });
        removeCookie('username', { path: '/' });
        removeCookie('administrator', { path: '/' });

        navigate('/auth/login');
    };

    const switchItem = isOnIdea
        ? {
            key: 'user-mode',
            label: '사용자 모드',
            icon: <HomeOutlinedIcon fontSize='small' />,
            onClick: () => navigate('/chat')
        }
        : {
            key: 'idea',
            label: '창의혁신아이디어',
            icon: <LightbulbOutlinedIcon fontSize='small' />,
            onClick: () => navigate('/idea')
        };

    const menuItems = [
        switchItem,
        ...(isAdmin
            ? [
                {
                    key: 'admin-mode',
                    label: '관리자 모드',
                    icon: <AdminPanelSettingsOutlinedIcon fontSize='small' />,
                    onClick: () => navigate('/admin')
                }
            ]
            : []
        ),
        {
            key: 'logout',
            label: '로그아웃',
            icon: <LogoutRoundedIcon fontSize='small' />,
            onClick: handleLogout
        }
    ];

    return (
        <MenuList sx={{ width: 'auto', minWidth: 160, py: '8px', bgcolor: 'background.paper', border: 1, borderColor: 'elevation.outlined', borderRadius: 1, boxShadow: 0, position: 'absolute', left: 'calc(100% - 4px)', bottom: 4, zIndex: 10 }}>
            {menuItems.map((item) => {
                const { key, label, icon, onClick } = item;

                return (
                    <MenuItem key={key} onClick={onClick}>
                        <ListItemIcon>{icon}</ListItemIcon>
                        <ListItemText
                            primary={label}
                            primaryTypographyProps={{ variant: 'subtitle3' }}
                        />
                    </MenuItem>
                );    
            })}
        </MenuList>
    );
}
